import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import useModalLink from '../../hooks/useModalLink';

import useQuery from '../../hooks/useQuery';
import { USE_MODAL_QUERY_PARAM } from '../../routes';
import { getRedirectToUrl, isExternalRoute } from '../../utils/Routes';
import LoadingIndicator from '../shared/LoadingIndicator';
import Env from '../../utils/env';
import { setCookie } from '../../utils/AuthCookie';

const { TEACHER_PORTAL } = Env;
interface Props {
  redirectTo: string
}

/**
 * Forward the user to the "redirectTo" query parameter if present, else the redirectTo prop,
 * which is a function of both registering/creating of parent/eductor and passed by
 * the Regististration or Login component.
 */
const NewSessionHandler = ({ redirectTo }: Props): React.ReactElement => {
  const queryParams = useQuery();
  const history = useHistory();
  const openModal = useModalLink();

  const redirectToParam = queryParams.get('redirectTo');
  // The teacher portal ignores redirectTo parameter, and will always redirect to the Islands selector
  const redirectUrl = TEACHER_PORTAL ? redirectTo : getRedirectToUrl(redirectTo, redirectToParam);

  useEffect(() => {
    /**
     * Set a cookie that will allow the WordPress site to establish that an authenticated user is
     * requesting access to resources
     */

    setCookie();

    if (isExternalRoute(redirectUrl)) {
      window.location.href = redirectUrl;
    } else if (redirectUrl.search(USE_MODAL_QUERY_PARAM) > -1) {
      openModal(redirectUrl);
    } else {
      history.push(redirectUrl);
    }
  }, []);

  return <LoadingIndicator />;
};

export default NewSessionHandler;
